import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as date from "../../booking/helpers/date"
import { DateTime } from "luxon"
import { handleEvalTracking, trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItinerarySection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      showMerchantInfoModal: props.showMerchantInfoModal,
      airlinesPageLink: props.airlinesPageLink,
      accordionOpen: false,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasContentBlocks = this.props.block.contentArea?.length > 0

    let buttonLink = this.props.block.buttonLink
    if (this.props.block.linkToAirlineBool) buttonLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    if (this.props.block.buttonAddParkingQueryString) {
      const ROUNDING = 30 * 60 * 1000 /*ms*/
      const dtLocale = date.luxonLocale(this.state.flightInfo.language)
      const zone = "Europe/Copenhagen"
      const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
      const flightInfoDate = estimatedPublicTime.minus({ minutes: this.props.checkInOpens }).minus({ minutes: 60 })
      const roundedDate = DateTime.fromMillis(Math.round(+flightInfoDate.toMillis() / ROUNDING) * ROUNDING)
        .setLocale(dtLocale)
        .setZone(zone)
      buttonLink += `?ad=${roundedDate.toFormat("yyyy-MM-dd")}&at=${roundedDate.toFormat("HH")}:00` // floor to the hour
    }

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem foldable ${theme ? theme : ""}`}
      >
        <button
          className={"departure-info__essentials__detailitems__detailitem__header pointer"}
          aria-label={
            this.state.accordionOpen
              ? `${this.props.currentPageJson?.closeContentLabel || "Luk indhold for sektionen"} ${this.props.block.heading}`
              : `${this.props.currentPageJson?.openContentLabel || "Åben indhold for sektionen"} ${this.props.block.heading}`
          }
          onClick={(e) => this.handleAccordionClick(e)}
        >
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </button>
        <div className={"contentWrapper show-hide hide-content"}>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText, true, this.state.accordionOpen) : ""}
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasContentBlocks ? this.renderContentBlocks(this.state.block.contentArea, true, this.state.accordionOpen) : ""}
        </div>
      </div>
    )
  }
}
